import { theme } from '@tribeplatform/design-system/themes/default'
import { DEFAULT_STYLE } from '@tribeplatform/react-ui-kit/ThemeProvider'

import { colorTemplates } from './colors/templates.js'
import { Theme } from './types.js'

export const BASE_THEME: Theme = {
  id: 'default',
  colors: colorTemplates.find(template => template.name === 'Default').colors,
  newColors: theme,
  typography: {
    theme: 'system',
    style: DEFAULT_STYLE,
  },
}
